import React from "react";
import RichText from "components/rich-text";
import { getRgba } from "helpers/get-rgba";

const TasteBar = ({ name, amount, color = "black" }) => (
	<div className="flex flex-col items-start my-2">
		<p className="text-md">{name}</p>
		<div className="flex w-[20em] md:w-[27.5em] h-7 p-1 rounded-xl">
			{[...Array(5)].map((_, index) => (
				<div
					key={index}
					style={{ backgroundColor: index < amount ? getRgba(color) : "transparent" }}
					className="flex-1 m-[0.25px] rounded-xl border-[0.25px] border-gray-400"
				/>
			))}
		</div>
	</div>
);

const TasteGraph = ({ data: { content, graphs } }) => (
	<div className="flex flex-col">
		<div className="w-full flex flex-col md:flex-row justify-between">
			<div className="w-full md:w-2/4">
				<RichText value={content}/>
			</div>

			<div className="w-3/4 flex flex-col justify-center items-center self-center py-4 md:py-12">
				{graphs.map((item) => (
					<TasteBar key={item._key} name={item.name} amount={item.amount} color={item.color} />
				))}
			</div>
		</div>
	</div>
);

export default TasteGraph;
